<template>
  <v-data-table
    :headers="headers"
    :items="carrier_data"
    sort-by="name"
    class="elevation-3"
    @click:row="handleClick"
    disable-pagination
    :hide-default-footer="true"
    :loading="loading"
    loading-text="Loading... Please wait"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Carriers</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              New Carrier
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="8">
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-checkbox
                      v-model="editedItem.featured"
                      label="Featured"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" text @click="save">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.featured="{ item }">
      <v-icon v-if="item.featured">mdi-check</v-icon>
      <v-icon v-else>mdi-close</v-icon>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click.stop="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon small @click.stop="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import gql from "graphql-tag";
import dayjs from "dayjs";

export default {
  name: "CarriersTable",

  data: () => ({
    carrier_data: [],
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Carrier Name",
        value: "name",
      },
      { text: "Featured", value: "featured" },
      { text: "Products", value: "product_cnt" },
      { text: "Last Updated", value: "updated" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id: 0,
      product_cnt: 0,
      name: null,
      featured: false,
    },
    defaultItem: {
      id: 0,
      product_cnt: 0,
      name: null,
      featured: false,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Carrier" : "Edit Carrier";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.loading = true;

      let fetchPolicy = "cache-first";

      const { data } = await this.$apollo.query({
        fetchPolicy: fetchPolicy,
        query: gql`
          query {
            carriers {
              id
              name
              featured
              updated_at
              products_aggregate {
                aggregate {
                  count
                }
              }
            }
          }
        `,
      });

      this.carrier_data = data.carriers;

      this.carrier_data.forEach((item) => {
        item.product_cnt = item.products_aggregate.aggregate.count;
        item.updated = dayjs(item.updated_at).format("MM/DD/YYYY");
      });

      this.loading = false;
    },
    handleClick: function(e) {
      this.$router.push(`/carrier/${e.id}`);
    },
    editItem(item) {
      this.editedIndex = this.carrier_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.carrier_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.carrier_data.splice(this.editedIndex, 1);

      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: Int!) {
              delete_carriers_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.editedItem.id,
          },
        })
        .then(({ data }) => {
          console.log("result", data);
          this.$store.state.snackbar.show = true;
          this.$store.state.snackbar.text = "Carrier Deleted";
        })
        .catch((error) => {
          console.log(error);
          alert("ERROR OCCURED");
        });

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        // update
        console.log(this.editedItem);

        this.$apollo
          .mutate({
            mutation: gql`
              mutation($id: Int!, $name: String!, $featured: Boolean!) {
                update_carriers(
                  where: { id: { _eq: $id } }
                  _set: { name: $name, featured: $featured }
                ) {
                  returning {
                    id
                    name
                    featured
                  }
                }
              }
            `,
            variables: {
              id: this.editedItem.id,
              name: this.editedItem.name,
              featured: this.editedItem.featured,
            },
          })
          .then(({ data }) => {
            console.log(data);
            this.$store.state.snackbar.show = true;
            this.$store.state.snackbar.text = "Carrier Updated";
          })
          .catch((error) => {
            console.log(error);
            alert("ERROR OCCURED");
          });
        this.editedItem.updated = dayjs().format("MM/DD/YYYY");
        Object.assign(this.carrier_data[this.editedIndex], this.editedItem);
      } else {
        // create
        this.$apollo
          .mutate({
            mutation: gql`
              mutation($name: String, $featured: Boolean) {
                insert_carriers_one(
                  object: { name: $name, featured: $featured }
                ) {
                  id
                  name
                  featured
                }
              }
            `,
            variables: {
              name: this.editedItem.name,
              featured: this.editedItem.featured,
            },
          })
          .then(({ data }) => {
            data.insert_carriers_one.product_cnt = 0;
            data.insert_carriers_one.updated = dayjs().format("MM/DD/YYYY");
            console.log(data);
            this.carrier_data.push(data.insert_carriers_one);
            this.$store.state.snackbar.show = true;
            this.$store.state.snackbar.text = "Carrier created";
          })
          .catch((error) => {
            console.log(error);
            alert("ERROR OCCURED");
          });
      }
      this.close();
    },
  },
};
</script>
